import type { Writable } from "type-fest";

export function makeDevConsole(callback?: (key: keyof Console, args: unknown[]) => void) {
  const c = globalThis.console;
  const devConsole: Console = (Object.keys(c) as (keyof Console)[]).reduce(
    (acc: Writable<Console>, key: keyof Console) => {
      if (c[key] instanceof Function) {
        if (!callback) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore-next-line
          acc[key] = c[key];
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore-next-line
          acc[key] = (...args) => {
            callback(key, args);
          };
        }
      } else {
        Object.defineProperty(acc, key, {
          enumerable: true,
          get() {
            return c[key];
          },
        });
      }
      return acc;
    },
    {} as Writable<Console>,
  );

  return devConsole;
}
